module.exports = __webpack_public_path__ + "static/media/white.22d3e915.svg";